if (!customElements.get('custom-tp-transformation-slider')) {
  customElements.define(
    'custom-tp-transformation-slider',
    class CustomTpTransformationSlider extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-tp-transformation-slider]');
        this.originalCount = Number(this.slider?.dataset.originalCount) || 0;
        this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');

        this.onSectionLoad = this.onSectionLoad.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);

        document.addEventListener('shopify:section:load', this.onSectionLoad);
        this.mobileMediaQuery.addEventListener('change', this.onMediaChange);

        this.initSlider();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
        this.destroySlider();
      }

      onSectionLoad(event) {
        if (event.target?.contains(this)) {
          this.destroySlider();
          this.initSlider();
        }
      }

      onMediaChange() {
        this.destroySlider();
        this.initSlider();
      }

      async initSlider() {
        if (!this.slider || !this.mobileMediaQuery.matches || this.originalCount === 0) {
          return;
        }

        if (this.slider.swiper) {
          return;
        }

        this.previousButton = this.querySelector('[data-tp-transformation-prev]');
        this.nextButton = this.querySelector('[data-tp-transformation-next]');
        this.pagination = this.querySelector('[data-tp-transformation-dots]');

        await this.waitForSwiper();

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 'auto',
          spaceBetween: 9,
          loop: true,
          centeredSlides: true,
          allowTouchMove: true,
          grabCursor: true,
          speed: 500,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.previousButton,
          },
          pagination: {
            el: this.pagination,
            type: 'bullets',
            clickable: true,
            bulletClass: 'custom-tp-transformation-slider__dot',
            bulletActiveClass: 'is-active',
            renderBullet: (index, className) => {
              if (this.originalCount > 0 && index >= this.originalCount) {
                return `<button class="${className}" type="button" tabindex="-1" aria-hidden="true" style="display:none"></button>`;
              }

              return `<button class="${className}" type="button" aria-label="Show result ${index + 1}"></button>`;
            },
          },
          on: {
            slideChange: (swiper) => {
              if (!this.originalCount || !this.pagination) {
                return;
              }

              const realIndex = swiper.realIndex % this.originalCount;
              const bullets = this.pagination.querySelectorAll('.custom-tp-transformation-slider__dot');

              bullets.forEach((bullet, index) => {
                bullet.classList.toggle('is-active', index === realIndex);
              });
            },
          },
        });
      }

      destroySlider() {
        this.swiper?.destroy?.();
        this.swiper = null;
      }

      waitForSwiper() {
        return new Promise((resolve) => {
          if (window.Swiper) {
            resolve();
            return;
          }

          const checkSwiper = () => {
            if (window.Swiper) {
              resolve();
              return;
            }

            window.setTimeout(checkSwiper, 50);
          };

          checkSwiper();
        });
      }
    }
  );
}
